module.exports = __webpack_public_path__ + "img/home01.44520674.jpg";